/**
 * Copy text to the clipboard, with a fallback for browsers and contexts where the async Clipboard
 * API is unavailable (notably any non-secure origin).
 *
 * Extracted from the two near-identical copies in pages/admin/ObservatoryEditPage.js and
 * pages/admin/ApiKeyManagement.js when the user API key UI (#1115) needed a third — that is the
 * point at which duplication becomes a maintenance problem.
 *
 * @returns {Promise<boolean>} whether the text reached the clipboard.
 */
export async function copyToClipboard(text) {
  if (!text) return false;

  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Permission denied or an insecure context that lied — fall through.
    }
  }

  // Legacy path: a hidden textarea plus execCommand. Kept because the reveal dialog shows a secret
  // exactly once, so "copy silently did nothing" is a genuinely costly failure.
  try {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

/** Select the whole value of a MUI TextField — multiline nests the real element, hence the query. */
export function selectAllOnClick(event) {
  const el = event.target.querySelector?.('textarea, input') || event.target;
  el.select?.();
}

export default copyToClipboard;
